<template xmlns:el-col="http://www.w3.org/1999/html">
  <div class="add-product-add" v-loading.lock="fullscreenLoading">
    <div class="crumbs-navigation">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/main' }">我的报价单</el-breadcrumb-item>
        <el-breadcrumb-item><a @click="toSecond">产品配置组</a> </el-breadcrumb-item>
        <el-breadcrumb-item><a @click="selectProduct"> 已添加产品</a></el-breadcrumb-item>
        <el-breadcrumb-item> 添加产品</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div ref="headtap">
      <el-form ref="form" :model="form" :inline="true">
        <el-row>
          <el-col :span="20">
            <el-form-item label="价格总计：">
              （<span class="f-blue">{{ productPriceFormat(null,null,totalPrice) }}</span>）
            </el-form-item>
            <el-form-item>&nbsp;</el-form-item>
            <el-form-item label="数量总计：">
              （<span class="f-blue">{{ totalNumber }}</span>）
            </el-form-item>
            <el-form-item>&nbsp;</el-form-item>
            <el-form-item prop="lineProperty" label-width="200px">
              <el-select v-model="form.lineProperty" filterable clearable reserve-keyword placeholder="产品分类"
                         :loading="loading" value-key="propertyCode" @change="seachForm"
              >
                <el-option
                  v-for="item in allLinePropertyMap"
                  :key="item.propertyCode"
                  :label="item.propertyName"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item>&nbsp;</el-form-item>
            <el-form-item class="grid-content" prop="keys">
              <el-input v-model="form.keys" placeholder="通过产品型号、描述模糊搜索" @keyup.enter.native="seachForm"
                        style="width: 250px"
              />
            </el-form-item>
            <el-form-item>&nbsp;</el-form-item>
            <el-form-item prop="userCollection">
              <el-checkbox v-model="form.userCollection" true-label="userCollection" false-label="" @change="seachForm">
                我的收藏
              </el-checkbox>
            </el-form-item>
            <el-form-item>&nbsp;</el-form-item>
            <el-form-item>
              <el-button type="primary" @click="seachForm()">搜索</el-button>
            </el-form-item>
            <el-form-item>&nbsp;</el-form-item>
            <el-form-item>
              <el-button @click="resetForm('form')">重置</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="4" align="right">
            <el-button type="primary" @click="goback">返回</el-button>
            <el-button type="primary" @click="createProductGroupSubItem">保存</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="clear" />
    </div>
    <table>
      <tr v-for="(item,j) in productRuleList" :key="j">
        <td style="text-align: left">
          <span style="color:red">产品【{{ item.productName }}】的配置建议为：{{ item.configurationadvice }}</span>
        </td>
      </tr>
    </table>
    <div class="table" ref="headtable">
      <el-table
        id="table0001"
        :data="ProductInitListVO"
        border
        style="width: 100%"
        :cell-style="changeStyle"
      >
        <el-table-column
          prop="productName"
          label="产品型号"
          min-width="15%"
          align="left"
        >
          <template slot-scope="scope">
            <ProductNameFormation :scope="scope" />
          </template>
        </el-table-column>
        <el-table-column
          label="产品描述"
          :render-header="foo"
          min-width="20%"
          align="left"
        >
          <template slot-scope="scope">
            <long-text :text="scope.row.productDesc" :switch-flg="switchFlgP" />
          </template>
        </el-table-column>

        <el-table-column
          prop="productPrice"
          label="价格（元）"
          min-width="5%"
          align="center"
          :formatter="productPriceFormat3"
        />
        <el-table-column
          prop="purchaseQuantity"
          label="数量"
          min-width="10%"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number size="mini" controls-position="right" v-model="scope.row.purchaseQuantity" :min="0" :precision="0" :max="scope.row.optionalType === 1 && scope.row.subPropertyName === '主机' ? 1 : 99999" @change="numberChange(scope.$index);getWeakCorrelation(scope.row.productCode,scope.row.purchaseQuantity)" style="width: 80px" />
          </template>
        </el-table-column>
        <el-table-column
          prop="productStatus"
          label="状态"
          min-width="5%"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.productStatus=='0'" style="color:#606266;">量产</span>
            <span v-if="scope.row.productStatus=='1'" style="color: red;"><span v-if="scope.row.formalStopTime != null">{{ scope.row.formalStopTime }}</span>停止下单</span>
            <span v-if="scope.row.productStatus=='2'" style="color: red;">剩余库存清理</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="productType"
          label="类型，备货周期"
          min-width="6%"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.productType }}<span v-if="isNotNull(scope.row.productType)">类</span><span v-if="isNotNull(scope.row.productType)&&isNotNull(scope.row.deliveryPeriod)">，</span><span v-if="isNotNull(scope.row.deliveryPeriod)">{{ scope.row.deliveryPeriod }}天</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="productPscType"
          label="服务分类"
          min-width="3%"
          align="left"
        />
        <el-table-column
          label="特殊说明"
          :render-header="foo"
          min-width="20%"
          align="left"
        >
          <template slot-scope="scope">
            <long-text :text="notesTextFormat(scope.row.notes,scope.row.supplyRemarks)" :switch-flg="switchFlgP" />
          </template>
        </el-table-column>
        <el-table-column
          label="更多"
          min-width="5%"
          align="center"
        >
          <template slot-scope="scope">
            <MoreContent :scope="scope" :is-partner="isPartner" />
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="4%"
          align="center"
        >
          <template slot-scope="scope">
            <ProductOperate :scope="scope" />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import api from '../../api';
import longText from '../quotationlist/longText';
import eventBus from '@/utils/eventBus';
import { productPriceFormat, changeStyle, productPriceFormat3 } from '../../utils/numberFormater';
import MoreContent from './MoreContent';
import { isPartnerM, isNotNull, isControlled, notesTextFormat } from '@/utils/mUtils';
import ProductNameFormation from '../components/ProductNameFormation';
import ProductOperate from '../components/ProductOperate';
import { ProductRule } from '@/utils/productRule';
export default {
  name: 'AdditionProduct',
  mixins: [ProductRule],
  data () {
    return {
      formLabelWidth: '120px',
      dialogFormVisible: false,
      configurationGroup: {
        projectId: '',
        groupId: '',
        subId: '',
        groupName: '',
        isService: false
      },
      form: {
        lineProperty: '',
        keys: '',
        userCollection: ''
      },
      allLinePropertyMap: [],
      loading: false,
      // 表单验证
      rules: {
        groupName: [{ required: true, message: '请输入配置组名称', trigger: 'blur' }, { max: 40, message: '不能超过40个字符' }]
      },

      ProductInitListVO: [],
      notloading: true,
      ifshow: true,
      fullscreenLoading: true,
      screenWidth: document.body.clientWidth, // 这里是给到了一个默认值 （这个很重要）
      switchFlgP: true,
      totalRiilPrice: 0,
      isPartner: true
    };
  },
  mounted () {
    this.isPartner = isPartnerM();
    const that = this;
    that.configurationGroup.groupId = that.$route.params.groupId;
    that.configurationGroup.projectId = that.$route.params.projectId;
    that.configurationGroup.subId = that.$route.params.subId;
    that.configurationGroup.groupName = that.$route.params.groupName;
    that.configurationGroup.isService = that.$route.params.isService;
    this.getSubProperty();

    that.initGetProductList();
    this.getHostValidate(this.configurationGroup.subId);

    // window.addEventListener('scroll',this.handleScroll);

    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
    window.onscroll = () => {
      let height = document.documentElement.scrollTop || document.body.scrollTop;
      if (height > 95) {
        this.$refs.headtap.className = 'fixed';
        this.$refs.headtable.style.marginBottom = '150px';
      } else {
        this.$refs.headtap.className = '';
        this.$refs.headtable.style.marginBottom = '20px';
      }
    };
  },
  watch: {
    screenWidth (val) {
      this.screenWidth = val;
    }
  },
  components: { longText, MoreContent, ProductNameFormation, ProductOperate },
  methods: {
    productPriceFormat,
    productPriceFormat3,
    changeStyle,
    isNotNull,
    isControlled,
    notesTextFormat,
    // 跳转至配置组
    toSecond () {
      this.$router.push({ name: 'CreatOrderSecond/second', query: { projectId: this.configurationGroup.projectId } });
    },
    // 重置搜索框
    resetForm (formName) {
      // 重置产品大类列表数据
      this.$refs[formName].resetFields();
      this.seachForm();
    },
    // 搜索功能
    seachForm () {
      let propertyCode = '';
      if (this.form.lineProperty && this.form.lineProperty.propertyCode) {
        propertyCode = this.form.lineProperty.propertyCode;
      }
      let param = {
        params: {
          seriesId: this.$route.params.seriesId,
          subId: this.$route.params.subId,
          isServiceFlag: this.configurationGroup.isService,
          keys: this.form.keys,
          userCollection: this.form.userCollection,
          propertyCode: propertyCode
        }
      };
      this.fullscreenLoading = true;

      api.getProductList(param).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.ProductInitListVO = json.data;
        } else {
          this.$notify.error(json.err);
        }
        this.fullscreenLoading = false;
      }).catch(() => {
        this.fullscreenLoading = false;
        this.$notify.error('网络异常！');
      });
    },

    // 初始加载添加产品列表
    initGetProductList () {
      let param = {
        params: {
          seriesId: this.$route.params.seriesId,
          subId: this.$route.params.subId,
          isServiceFlag: this.configurationGroup.isService,
          keys: '',
          userCollection: ''
        }
      };
      this.fullscreenLoading = true;
      api.getProductList(param).then((res) => {
        let json = res.data;
        // console.log(json);
        if (json.status === '200') {
          this.ProductInitListVO = json.data;
          this.fullscreenLoading = false;
        } else {
          this.$notify.error(json.err);
        }
        this.fullscreenLoading = false;
      }).catch((e) => {
        this.fullscreenLoading = false;
        this.$notify.error('网络异常！');
        console.error('e', e);
      });
    },
    getGroupType () {
      let groupType = 1;
      if (this.configurationGroup.isService) {
        groupType = 2;
      }
    },
    // 添加至配置组
    createProductGroupSubItem () {
      if (this.ProductInitListVO.find((item) => item.purchaseQuantity > 0) != null) {
        this.fullscreenLoading = true;
        let body = {
          groupId: this.configurationGroup.groupId,
          projectId: this.configurationGroup.projectId,
          subId: this.configurationGroup.subId,
          groupType: this.getGroupType(),
          productInitListVOS: this.ProductInitListVO.filter((item) => item.purchaseQuantity > 0)
        };
        api.addProductGroupSubItem(body).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.initGetProductList();
            // console.log("this.configurationGroup.groupName",this.configurationGroup.groupName);
            // 跳转到已添加产品
            // this.$notify.success("添加至配置组成功！");
            this.$message({
              showClose: true,
              duration: 800,
              message: '添加至配置组成功！',
              type: 'success'
            });
          } else {
            this.$notify.error(json.err);
          }
        }).catch(() => {
          this.fullscreenLoading = false;
          this.$notify.error('网络异常！');
        });
      } else {
        this.$message({
          showClose: true,
          duration: 800,
          message: '您没有选择任何产品!',
          type: 'error'
        });
        // this.$notify.error("您没有选择任何产品！");
      }
    },
    goback () {
      this.$router.push({ name: 'AddedProduct/added', params: { groupId: this.configurationGroup.groupId, projectId: this.configurationGroup.projectId, groupName: this.configurationGroup.groupName, isService: this.configurationGroup.isService } });
    },
    productDesc (val) {
      let cont = '';
      if (this.screenWidth <= 1440) {
        cont = val.length > 20 ? val.substring(0, 20) : val;
        return cont;
      } else {
        cont = val.length > 35 ? val.substring(0, 35) : val;
        return cont;
      };
    },
    changText (row) {
      if (row.ifShow === undefined) {
        this.$set(row, 'ifShow', true);
      } else {
        row.ifShow = !row.ifShow;
      }
    },
    numberChange (index) {
      if (this.ProductInitListVO[index].purchaseQuantity == undefined) {
        this.$set(this.ProductInitListVO[index], 'purchaseQuantity', 1);
        this.$nextTick(() => {
          this.ProductInitListVO[index].purchaseQuantity = 0;
        });
      }
    },
    foo (h, { column }) {
      if (column.label) {
        return (h('span', {},
          [h('span', [column.label]),
            h('button', {
              attrs: { style: 'float:right;background:rgba(54,186,226,0.6);color:#ffffff;border:none;border-radius:5px;height:2rem' },
              on: {
                click: () => {
                  this.expandDiscribe();
                }
              }
            }, ['全部展开或关闭'])]));
      }
    },
    expandDiscribe () {
      // longText.expandDisc();
      this.switchFlgP = !this.switchFlgP;
      eventBus.$emit('longTextDisc');
    },
    selectProduct () {
      // 509388693589463040?groupName=Site_1&projectId=509388693547524096
      this.$router.push({ name: 'AddedProduct/added', params: { groupId: this.configurationGroup.groupId, projectId: this.configurationGroup.projectId, isService: this.configurationGroup.isService } });
    },
    getRiilPrice () {
      if (this.totalRiilPrice == 0) {
        api.getRiilProductTotalPriceByProjectId(this.configurationGroup.projectId).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.totalRiilPrice = json.data;
          }
        });
      }
    },
    // 获取产品分裂列表
    getSubProperty () {
      let param = {
        params: {
          subId: this.configurationGroup.subId
        }
      };
      api.getSubProperty(param).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          // console.log(this.allLinePropertyMap);
          this.allLinePropertyMap = json.data;
        } else {
          this.$notify.error(json.err);
        }
      }).catch(() => {
        this.$notify.error('网络异常！');
      });
    }
  },
  computed: {
    // 数量总计
    totalNumber () {
      let cont = 0.00;
      this.ProductInitListVO.forEach((item) => {
        cont = cont + item.purchaseQuantity;
      });
      return cont;
    },
    // 计算价格总计
    totalPrice () {
      let addPrice = 0;
      let cur = this;
      if (cur.configurationGroup.isService == true) {
        // 若当前编辑的是服务配置组，则发送后台服务端计算整单中riil的产品价格，然后返回，计算当前添加的服务产品的list 价
        cur.getRiilPrice();
        cur.ProductInitListVO.forEach((item) => {
          if (cur.totalRiilPrice != 0) {
            addPrice += cur.totalRiilPrice * item.retailPriceFloatingRate * (item.purchaseQuantity == null ? 0 : item.purchaseQuantity);
            if (item.purchaseQuantity != null && item.purchaseQuantity != 0) {
              item.productPrice = (item.purchaseQuantity == null ? 0 : cur.totalRiilPrice * item.retailPriceFloatingRate);
            }
          } else {
            addPrice += 0;
          }
        });
      } else {
        this.ProductInitListVO.forEach((item) => {
          addPrice += (item.purchaseQuantity == null ? 0 : item.purchaseQuantity) * item.productPrice;
        });
      }
      return addPrice.toFixed(2);
    }
  }
};
</script>

<style type="text/css">
  @import "../../styles/product-common.css";

  .add-product-add  .el-form-item__content{
    height: 3.2rem;
    line-height: 3.2rem;
  }

  .add-product-add .f-l{
    float: left;
  }
  .add-product-add .table{
    margin-top:0px;
    margin-bottom: 100px;
  }

  .add-product-add  .el-button--primary:hover {
    color: #fff;
    background-color: #60c8e8!important;
    border-color: #60c8e8!important;
  }

  .clear{
    clear:both;
  }

  .add-product-add .el-form-item{
    float: left;
    margin-right: 0;
    margin-bottom: 0;
  }

  .add-product-add .table .el-table .cell{
    white-space:normal;
  }

  /*设置描述*/

  .add-product-add .cell:hover .el-tag {
    /*background: none;*/
    border: 1px solid #36BADE;
  }

  .add-product-add .el-tag {
    text-overflow: ellipsis;
    display: inline-block;
    border: transparent;
    margin: 0;
    cursor: pointer;
  }

  .add-product-add .el-tag img{
    width: 24px;
  }

  .add-product-add .el-dialog__body{
    margin: 20px 0 60px 0;
  }

  .add-product-add .dialog-footer{
    text-align: center;
  }

  .el-popover{
    width: 300px;
  }
  @media screen and (max-width: 1366px) {
    .add-product-add table tr,
    .add-product-add table tr th,
    .add-product-add table tr td,
    .add-product-add table tr td .el-button--text
    {
      height: 2rem;
      font-size: 1.2rem;
      padding: 0;
      margin: 0;
    }

    .add-product-add .el-form-item{
      margin-bottom: 0.5rem;
    }
  }

  @media screen and (max-width: 1280px) {
    .add-product-add{
      width: 1240px;
    }
  }
</style>
